/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RemuneracaoControlItem from './RemuneracaoControlItem';

class DadosRemuneracaoControl extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    // idPrimeiraTab: null,
  });
  /* Organiza a lista de remunerações */

  criarRemuneracoesPorAno = () => {
    const formRemuneracoesAno = [];
    let anoInicio = 0;
    let anoFim = 0;

    if ((this.props.intervalo !== null && this.props.intervalo !== undefined)) {
      anoInicio = Number(this.props.intervalo.split('-')[0]);
      anoFim = Number(this.props.intervalo.split('-')[1]);
    }

    if (this.props.anoEscolhido && this.props.operacaoRemuneracao === 2) {
        formRemuneracoesAno.push(<RemuneracaoControlItem
          remuneracoesAtividade={this.props.remuneracoesAtividade}
          handleChange={this.props.handleChange}
          atualizarListaRemuneracao={this.props.atualizarListaRemuneracao}
          anoEscolhido={this.props.anoEscolhido}
          remuneracoesPreenchidas={this.props.remuneracoesPreenchidas}
          tabAtiva={this.props.tabAtiva}
          desabilitarCampos={this.props.desabilitarCampos}
          preencherValoresAutomaticamente={this.props.preencherValoresAutomaticamente}
          alertarPreenchimentoAutomatico={this.props.alertarPreenchimentoAutomatico}
          limparValoresAutomaticamente={this.props.limparValoresAutomaticamente}
          alertarLimpezaAutomatica={this.props.alertarLimpezaAutomatica}
          verificarHabilitacaoBotaoLimpeza={this.props.verificarHabilitacaoBotaoLimpeza}
          acao={this.props.acao}
        />);
    } else {
      if ((anoInicio !== 0 && anoFim !== 0)) {
        for (let index = anoInicio; index <= anoFim; index += 1) {
          formRemuneracoesAno.push(<RemuneracaoControlItem
            remuneracoesAtividade={this.props.remuneracoesAtividade}
            handleChange={this.props.handleChange}
            atualizarListaRemuneracao={this.props.atualizarListaRemuneracao}
            anoEscolhido={index}
            remuneracoesPreenchidas={this.props.remuneracoesPreenchidas}
            tabAtiva={this.props.tabAtiva}
            desabilitarCampos={this.props.desabilitarCampos}
            preencherValoresAutomaticamente={this.props.preencherValoresAutomaticamente}
            alertarPreenchimentoAutomatico={this.props.alertarPreenchimentoAutomatico}
            limparValoresAutomaticamente={this.props.limparValoresAutomaticamente}
            alertarLimpezaAutomatica={this.props.alertarLimpezaAutomatica}
            verificarHabilitacaoBotaoLimpeza={this.props.verificarHabilitacaoBotaoLimpeza}
            acao={this.props.acao}
          />);
        }
      }
    }
    return formRemuneracoesAno;
  }

  render() {
    return (
      <React.Fragment>
        {this.criarRemuneracoesPorAno()}
      </React.Fragment>
    );
  }
}

DadosRemuneracaoControl.propTypes = {
  intervalo: PropTypes.string,
  tabAtiva: PropTypes.string,
  remuneracoesAtividade: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  atualizarListaRemuneracao: PropTypes.func.isRequired,
  remuneracoesPreenchidas: PropTypes.arrayOf(PropTypes.shape({
    competencia: PropTypes.string,
    valor: PropTypes.string,
  })).isRequired,
  listaCompetenciasPorAno: PropTypes.arrayOf(PropTypes.shape({
    competencia: PropTypes.string,
  })).isRequired,
  preencherValoresAutomaticamente: PropTypes.func.isRequired,
  operacaoRemuneracao: PropTypes.number.isRequired,
  anoEscolhido: PropTypes.number.isRequired,
  acao: PropTypes.string,
  limparValoresAutomaticamente: PropTypes.func.isRequired,
  verificarHabilitacaoBotaoLimpeza: PropTypes.func.isRequired,
};

export default DadosRemuneracaoControl;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/DadosRemuneracaoControl.jsx